<script>
import axios from 'axios'
export default
{
    methods:
    {
        fetch()
        {
            axios.get(process.env.API_URL + '/v1/admin/sitemenus').then(res => this.data = res.data )
        },

        create()
        {
            this.data.push({
                parent_id: null,
                is_active: false,
                order: 99,
                name: this.$t('GENERAL.NEW'),
                name_en: null,
                type: 'TOP',
                is_external: false,
                is_new_tab: false,
                href: null,
                to: null,
                params: {},
            })
            window.scrollTo(0, document.body.scrollHeight)
        },

    },

    data()
    {
        return {
            data: [],
        }
    },

    mounted()
    {
        this.fetch()
        this.$store.dispatch('fetchPosts')
    }

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.MENUS') }}</h4>
                    </div>
                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-success" @click="create">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-warning" @click="fetch">
                            <icon name="refresh"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <h4>Fejléc:</h4>
                <mv-menu-entry v-for="item in data" v-if="item.type == 'TOP'" :key="item.id" :model="item" @fetch="fetch"/>
                <hr>
                <h4>Lábléc:</h4>
                <mv-menu-entry v-for="item in data" v-if="item.type == 'BOTTOM'" :key="item.id" :model="item" @fetch="fetch"/>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Menus.vue